export const currencyFormatter = (amount, currency = 'USD') => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
  }).format(amount)
}

export const currencySymbols = {
  USD: '$',
  CAD: 'C$',
  GBP: '£',
  AUD: 'A$',
  EUR: '€',
  NGN: '₦',
  GHS: '₵',
  ZAR: 'R'
}

export const getCurrencySymbol = (currencyCode) => {
  return currencySymbols[currencyCode] || '$'
}

export const formatAmount = (amount, currency = 'USD') => {
  const symbol = getCurrencySymbol(currency)
  return `${symbol}${amount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`
}

export const getCurrencyByCountry = (countryCode) => {
  const currencies = {
    US: 'USD',
    CA: 'CAD',
    GB: 'GBP',
    AU: 'AUD',
    DE: 'EUR',
    FR: 'EUR',
    NG: 'NGN',
    GH: 'GHS',
    ZA: 'ZAR',
    AF: 'AFN',
    AL: 'ALL',
    DZ: 'DZD',
    AR: 'ARS',
    AM: 'AMD',
    AT: 'EUR',
    AZ: 'AZN',
    BH: 'BHD',
    BD: 'BDT',
    BY: 'BYN',
    BE: 'EUR',
    BZ: 'BZD',
    BJ: 'XOF',
    BT: 'BTN',
    BO: 'BOB',
    BA: 'BAM',
    BW: 'BWP',
    BR: 'BRL',
    BN: 'BND',
    BG: 'BGN',
    BF: 'XOF',
    BI: 'BIF',
    KH: 'KHR',
    CM: 'XAF',
    CL: 'CLP',
    CN: 'CNY',
    CO: 'COP',
    CR: 'CRC',
    HR: 'HRK',
    CU: 'CUP',
    CY: 'EUR',
    CZ: 'CZK',
    DK: 'DKK',
    DJ: 'DJF',
    DO: 'DOP',
    EC: 'USD',
    EG: 'EGP',
    SV: 'USD',
    EE: 'EUR',
    ET: 'ETB',
    FJ: 'FJD',
    FI: 'EUR',
    GA: 'XAF',
    GM: 'GMD',
    GE: 'GEL',
    GR: 'EUR',
    GT: 'GTQ',
    GN: 'GNF',
    HT: 'HTG',
    HN: 'HNL',
    HU: 'HUF',
    IS: 'ISK',
    IN: 'INR',
    ID: 'IDR',
    IR: 'IRR',
    IQ: 'IQD',
    IE: 'EUR',
    IL: 'ILS',
    IT: 'EUR',
    JM: 'JMD',
    JP: 'JPY',
    JO: 'JOD',
    KZ: 'KZT',
    KE: 'KES',
    KW: 'KWD',
    KG: 'KGS',
    LA: 'LAK',
    LV: 'EUR',
    LB: 'LBP',
    LS: 'LSL',
    LR: 'LRD',
    LY: 'LYD',
    LT: 'EUR',
    LU: 'EUR',
    MG: 'MGA',
    MW: 'MWK',
    MY: 'MYR',
    MV: 'MVR',
    ML: 'XOF',
    MT: 'EUR',
    MR: 'MRU',
    MU: 'MUR',
    MX: 'MXN',
    MD: 'MDL',
    MN: 'MNT',
    ME: 'EUR',
    MA: 'MAD',
    MZ: 'MZN',
    MM: 'MMK',
    NA: 'NAD',
    NP: 'NPR',
    NL: 'EUR',
    NZ: 'NZD',
    NI: 'NIO',
    KP: 'KPW',
    MK: 'MKD',
    NO: 'NOK',
    OM: 'OMR',
    PK: 'PKR',
    PA: 'USD',
    PG: 'PGK',
    PY: 'PYG',
    PE: 'PEN',
    PH: 'PHP',
    PL: 'PLN',
    PT: 'EUR',
    QA: 'QAR',
    RO: 'RON',
    RU: 'RUB',
    RW: 'RWF',
    SA: 'SAR',
    SN: 'XOF',
    RS: 'RSD',
    SL: 'SLL',
    SG: 'SGD',
    SK: 'EUR',
    SI: 'EUR',
    SO: 'SOS',
    ES: 'EUR',
    LK: 'LKR',
    SD: 'SDG',
    SR: 'SRD',
    SE: 'SEK',
    CH: 'CHF',
    SY: 'SYP',
    TW: 'TWD',
    TJ: 'TJS',
    TZ: 'TZS',
    TH: 'THB',
    TG: 'XOF',
    TN: 'TND',
    TR: 'TRY',
    TM: 'TMT',
    UG: 'UGX',
    UA: 'UAH',
    AE: 'AED',
    UY: 'UYU',
    UZ: 'UZS',
    VE: 'VES',
    VN: 'VND',
    YE: 'YER',
    ZM: 'ZMW',
    ZW: 'ZWD'
  }
  return currencies[countryCode] || 'USD'
}
